<template>
  <div class="project-one-bike-image-container" :style="`--headerHeight: ${headerHeight}px;`">
    <pdl-loading v-show="isLoading" :is-loading="isLoading" class="h-full" />
    <pdl-image
      qaid="project-one-bike-image"
      is-zoom
      custom-id="project-one-bike-image"
      class="project-one-bike-image"
      s7-asset-library="TrekBicycleProducts"
      :s7-asset-id="imageUrl"
      @onLoad="isLoading = false"
    />
  </div>
</template>

<script>
import {mapState} from 'vuex';
import {PdlLoading} from '@pedal/pdl-loading';
import {PdlImage} from '@pedal/pdl-image';

export default {
  name: 'ProjectOneBikeImage',

  components: {PdlLoading, PdlImage},

  data() {
    return {
      isLoading: true,
    };
  },

  computed: {
    // If there is an imageUrl then split this, get the second part of split, append '?' in the beginning,
    // otherwise pass empty string
    imageUrl() {
      return this.bikeData?.imageUrl ? `?${this.bikeData?.imageUrl?.split('?')[1]}` : '';
    },

    ...mapState('projectOne', ['bikeData']),
    ...mapState('global', ['headerHeight']),
  },

  watch: {
    imageUrl() {
      this.isLoading = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.project-one-bike-image-container {
  background: linear-gradient(180deg, var(--gray-10) 0%, var(--white) 46.63%, var(--gray-02) 100%);
  width: 100%;
  @screen lg {
    position: sticky;
    top: var(--headerHeight);
  }
}

.pdl-loading {
  aspect-ratio: 20/13;

  @screen lg {
    aspect-ratio: auto;
  }
}
</style>
